import {useEffect, useState} from 'react';

// Adopted from -> https://www.joshwcomeau.com/react/prefers-reduced-motion/#the-hook
const QUERY = '(prefers-reduced-motion: no-preference)';
const usePrefersReducedMotion = () => {
  // Default to no-animations, since we don't know what the
  // user's preference on the server. Only useful for SSR and will get overridden on render
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(true);
  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY);

    // If true (no preference), the user hasn't turned on reduced motion
    const hasNoPreference = window.matchMedia(QUERY).matches;

    // ChromeOS doesn't offer reduced motion so to be safe, we disable all animations not on windows or mac
    const appVersion = window.navigator.appVersion || '';
    const isWindowsOrMac = appVersion.includes('Mac') || appVersion.includes('Win');

    // oxlint-disable-next-line react/set-state-in-effect -- initial sync from the OS media query (external system) before subscribing to it
    setPrefersReducedMotion(!hasNoPreference || !isWindowsOrMac);

    // Register our event listener - updates if a user changes OS settings
    const listener = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(!event.matches);
    };
    mediaQueryList.addEventListener('change', listener);
    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, []);
  return prefersReducedMotion;
};

const requiresReducedMotion = () => {
  // If true (no preference), the user hasn't turned on reduced motion
  const hasNoPreference = window.matchMedia(QUERY).matches;

  // ChromeOS doesn't offer reduced motion so to be safe, we disable all animations not on windows or mac
  const appVersion = window.navigator.appVersion || '';
  const isWindowsOrMac = appVersion.includes('Mac') || appVersion.includes('Win');

  return !hasNoPreference || !isWindowsOrMac;
};

export {usePrefersReducedMotion, requiresReducedMotion};
